import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
export const DESTINATION_TITLE_QUERY = gql `
    query GetDestinationTitleFromId($request: GetDestinationTitleFromIdRequest!) {
        getDestinationTitleFromId(request: $request) {
            destinations {
                title
                id
                type
            }
        }
    }
`;
export function useDestinationTitle(destinations, sideEffects, skipQuery) {
    return useQuery(DESTINATION_TITLE_QUERY, {
        onCompleted: (data) => callSideEffects(sideEffects, data),
        ssr: false,
        skip: skipQuery,
        variables: {
            request: {
                destinations,
            },
        },
    });
}
